const dateFormatter = new Intl.DateTimeFormat('es-MX', {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
});

export interface ScheduleLabel {
  text: string;
  isToday: boolean;
  /** Programada para un dia que ya paso y sigue abierta. */
  isLate: boolean;
}

/** El dia de hoy en la zona del telefono, con el mismo formato que `scheduled_date`. */
function today(): string {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${String(now.getFullYear())}-${month}-${day}`;
}

/**
 * «Hoy», «Manana» o la fecha corta.
 *
 * Una fecha en cifras obliga a calcular si es la de hoy, y esa cuenta se hace
 * mal con prisa. La comparacion es entre cadenas `YYYY-MM-DD`, sin construir
 * un `Date` a partir de la fecha del servidor: `new Date('2026-09-01')` se
 * interpreta en UTC y en America adelanta la fecha un dia entero.
 */
export function scheduleLabel(scheduledDate: string): ScheduleLabel {
  const reference = today();

  if (scheduledDate === reference) {
    return { text: 'Hoy', isToday: true, isLate: false };
  }

  const parts = scheduledDate.split('-').map((value) => Number(value));
  const [year = 0, month = 1, day = 1] = parts;
  const local = new Date(year, month - 1, day);

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  if (local.getTime() === tomorrow.getTime()) {
    return { text: 'Manana', isToday: false, isLate: false };
  }

  return {
    text: dateFormatter.format(local),
    isToday: false,
    isLate: scheduledDate < reference,
  };
}
